// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chatGPTDialog > .el-dialog__header {\n    display: none;\n}\n.chatGPTDialog > .el-dialog__body {\n    padding: 0;\n}\n.chatGPTDialog > .el-dialog__body > .mobile-chat-wrapper {\n    height: 80vh;\n}\n", ""]);
// Exports
module.exports = exports;
